// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"0064f5c1","58":"e9ba6e97","174":"c7ad56d0","179":"7b376a5f","190":"0a6ce8db","256":"1d53c48f","338":"7933e1c1","480":"458d4c86","523":"10c869cf","643":"6c9d443b","734":"648500d9","751":"83dd8bb0","851":"113432e4","872":"866bb96b","963":"26f23146","990":"0f995f42"}[chunkId] + ".chunk.js";
};